import React, { useEffect, useState } from 'react'
import { Box, Text, Select } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import Spinner from '../../common/Spinner'
import { HealthServiceDataViewStatus } from './HealthStatusService'

import { useMarket } from '../../../utils/market'
import { deepClone } from '../../../utils/clone'

const HealthStatusServiceBouncer = ({ data, nodeName }) => {

    const marketLookup = useMarket()

    const tab_col = [
        {
            field: "id",
            headerName: "ID",
            minWidth: 150,
            suppressSizeToFit: true,
            checkboxSelection: true
        },
        {
            field: "primary",
            headerName: "Primary",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "marketName",
            headerName: "Market",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "reason",
            headerName: "Reason",
            minWidth: 200,

        },
        {
            field: "status",
            headerName: "Status",
            cellStyle: function (params) {
                if (params.value === 'DISABLED' || params.value === 'DISABLE' || params.value === "UP_SENDING_DISABLED") {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                }
                else if (params.value !== 'UP') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            },
            minWidth: 200,
        },
    ]

    const [tab_data, settab_data] = useState([])
    const [tab_data_original, settab_data_original] = useState([])

    const [markets, set_markets] = useState([])
    const [filtered_data, set_filtered_data] = useState([])

    useEffect(() => {
        if (marketLookup && data) {
            settab_data(Object.keys(data).sort((a, b) => (data[a].primary === 'P') ? 1 : -1).sort((a, b) => (data[a].status === 'UP') ? 1 : -1).reduce((rowData, rowId) => {

                const row = deepClone(data[rowId])

                if (!row.markets || row.markets.length === 0) {
                    row.markets = [0]
                }

                for (let marketName of row.markets) {
                    marketName = marketName ? marketName.replace("TT_MARKET_ID_", "") : "-"

                    rowData.push({
                        'uniqueId': row.id + "__" + marketName,
                        'id': row.id,
                        'marketName': marketName,
                        'reason': row.reason,
                        'status': row.status,
                        'primary': row.primary ? "P" : "S",
                        'detailView': {
                            'head': {
                            },
                            'data': [
                                {
                                    'type': 'account_detail',
                                    'subheader': 'Account',
                                    'content': {
                                        'accountId': row.id,
                                    }
                                },
                                {
                                    'type': 'graph_account',
                                    'subheader': 'Hierachy',
                                    'content': {
                                        'accountId': row.id,
                                    },
                                },
                            ],
                        },
                    })

                }
                return rowData
            }, []))

            settab_data_original(Object.keys(data).sort((a, b) => (data[a].primary === 'P') ? 1 : -1).sort((a, b) => (data[a].status === 'UP') ? 1 : -1).reduce((rowData, rowId) => {

                const row = deepClone(data[rowId])

                let markets = []

                if (!row.markets || row.markets.length === 0) {
                    row.markets = [0]
                }

                for (let marketName of row.markets) {
                    marketName = marketName ? marketName.replace("TT_MARKET_ID_", "") : "-"
                    if (marketName !== "-") {
                        markets.push(marketName)
                    }
                }

                rowData.push({
                    'uniqueId': row.id + "__" + row.reason,
                    'id': row.id,
                    'reason': row.reason,
                    'status': row.status,
                    'primary': row.primary ? "P" : "S",
                    'marketName': markets,
                    'detailView': {
                        'head': {
                        },
                        'data': [
                            {
                                'type': 'account_detail',
                                'subheader': 'Account',
                                'content': {
                                    'accountId': row.id,
                                }
                            },
                            {
                                'type': 'graph_account',
                                'subheader': 'Hierachy',
                                'content': {
                                    'accountId': row.id,
                                },
                            },
                        ],
                    },
                })

                return rowData
            }, []))

        }
        return () => {
            settab_data([])
        }
    }, [data, marketLookup])

    // Generate Market Names From Data
    useEffect(() => {
        if (tab_data) {
            let markets = [...new Set(tab_data.map(item => item.marketName))].sort()
            markets.unshift("ALL MARKETS")
            set_markets(markets)
        }
    }, [tab_data])

    const [selected_market, set_selected_market] = useState('ALL MARKETS');

    useEffect(() => {
        if (selected_market && tab_data && selected_market !== "ALL MARKETS") {
            let filteredData = tab_data.filter(x => x.marketName === selected_market)

            filteredData.sort(function (a, b) {
                return a.status === "UP" ? -1 : 1
            });

            filteredData.sort(function (a, b) {
                return a.primary === "P" ? 1 : -1
            });

            set_filtered_data(filteredData)
        } else if (selected_market && tab_data_original && selected_market === "ALL MARKETS") {
            set_filtered_data(tab_data_original)
        }
    }, [tab_data, selected_market, tab_data_original])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Accounts </Text>
                {filtered_data && <HealthServiceDataViewStatus tab_data={filtered_data.map(function (item) { return item["status"] })} />}
            </Box>

            {markets &&
                <Select
                    options={markets}
                    value={selected_market}
                    onChange={({ option }) => set_selected_market(option)}
                />
            }

            {!marketLookup && filtered_data
                ? <Spinner />
                :
                <AgDataTable
                    tab_col={tab_col}
                    tab_data={filtered_data}
                    tableName="HealthStatusServiceBouncer3"
                    defaultSubTab="Account"
                    countTitle="Accounts"
                    selection="multiple"
                    nodeName={nodeName}
                    tableHeight={700}
                />
            }
        </Box>
    )
}

export default HealthStatusServiceBouncer